module.exports = __webpack_public_path__ + "img/couples-006.1340973f.jpg";